import React from 'react';
import { IconInfoCircle } from '@tabler/icons-react';
import { NoteRoot, NoteText } from './styles';
import type { TariffServiceFeeNoteProps } from './types';

const ICON_SIZE = 18;

const TariffServiceFeeNote = ({ label }: TariffServiceFeeNoteProps) => (
  <NoteRoot role='note'>
    <IconInfoCircle size={ICON_SIZE} />
    <NoteText>{label}</NoteText>
  </NoteRoot>
);

export default TariffServiceFeeNote;
